(function () {
  'use strict';

  // ====================================================
  // CONFIG
  // ====================================================

  const DEFAULT_GAS_ENDPOINT =
    'https://script.google.com/macros/s/AKfycbwNw6WFAG7zr88_QdvOtuYo-39ZIjG2pf6hBI2MVCAdJK-yHBYNLibU-sEC80sLUlrC/exec';

  const DIRECT_GET_TIMEOUT_MS = 25000;
  const STATUS_GET_TIMEOUT_MS = 12000;
  const POLL_INTERVAL_MS = 1200;
  const POLL_TIMEOUT_MS = 60 * 1000;
  const CREATED_STATUS_MAX_MS = 30000;
  const STATUS_RETRY_MAX = 3;
  const STATUS_RETRY_DELAY_MS = 1500;

  const SHARE_APP_URL = 'https://onesdaily.com/pages/poop-character?share';
  const CARD_LOGO_DATA_URL = 'data:image/png;base64,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';

  const UPLOAD_MAX_SIDE = 900;
  const UPLOAD_INITIAL_QUALITY = 0.72;
  const UPLOAD_MIN_QUALITY = 0.58;
  const UPLOAD_MAX_DATA_URL_CHARS = 420000;

  const DIARY_STORAGE_KEY = 'onesdaily_poop_diary_v1';
  const DEFAULT_DIARY_URL = '/pages/poop-diary';

  const ASSET_BASE =
    'https://cdn.shopify.com/s/files/1/0725/1161/9372/files/';

  // marumarunだけ、正規化版アップロード時にShopifyが重複回避用suffixを付与。
  const MARUMARUN_FILES = {
    '01': 'dr-marumarun-var01_18f1f91d-88d2-4533-ae8d-bf9be8857525.png',
    '02': 'dr-marumarun-var02_1f09d452-b407-4d10-bdc6-b002b163a71b.png',
    '03': 'dr-marumarun-var03_64f6f327-9c69-477b-b2ef-c10f3604a246.png',
    '04': 'dr-marumarun-var04_0690b645-b83c-464e-8b9d-de4995e73df4.png',
    '05': 'dr-marumarun-var05_00c9c043-7086-4278-96c4-b83a83d38dc9.png',
    '06': 'dr-marumarun-var06_eab335d0-1cd2-4ed9-bcde-b663e7b47557.png',
    '07': 'dr-marumarun-var07_72c11a72-2fb8-4cf6-8391-7eb03550a950.png',
    '08': 'dr-marumarun-var08_d9507dd6-186b-4b5e-8250-99f7aa50f0c4.png',
    '09': 'dr-marumarun-var09_ee74f940-6795-450b-8ce5-0fd5df1e66c9.png',
    '10': 'dr-marumarun-var10_c4c71287-bff4-401e-87c0-9e300aa768a6.png'
  };

  // 解析色 → Canvas上で寄せる12色。
  // 色味を後で調整する場合は、この12色だけ触ればよい。
  const CHARACTER_COLORS = {
    BROWN_DARK: '#5b321f',
    BROWN_MEDIUM: '#8b542d',
    BROWN_LIGHT: '#b97843',
    YELLOW_BROWN: '#b98735',
    YELLOW: '#d6a83f',
    ORANGE: '#c8742e',
    GREEN_BROWN: '#777344',
    GREEN: '#6e7f46',
    BLACK: '#3f3934',
    RED_TINGED: '#9a5042',
    PALE_GRAY: '#a9a59b',
    WHITEISH: '#d6ccba'
  };

  // ====================================================
  // INIT
  // ====================================================

  function initAll() {
    document
      .querySelectorAll('[data-dr-poop-checker]')
      .forEach(function (root) {
        if (root.dataset.drPoopInitialized === 'true') return;
        root.dataset.drPoopInitialized = 'true';
        initChecker(root);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  // ====================================================
  // CHECKER
  // ====================================================

  function initChecker(root) {
    const gasEndpoint = root.dataset.gasEndpoint || DEFAULT_GAS_ENDPOINT;

    const photoInput = root.querySelector('[data-dr-photo]');
    const previewWrap = root.querySelector('[data-dr-preview-wrap]');
    const preview = root.querySelector('[data-dr-preview]');
    const fileName = root.querySelector('[data-dr-file-name]');
    const submitButton = root.querySelector('[data-dr-submit]');
    const loading = root.querySelector('[data-dr-loading]');
    const loadingTitle = root.querySelector('.dr-poop__loading-title');
    const loadingText = root.querySelector('.dr-poop__loading-text');
    const errorBox = root.querySelector('[data-dr-error]');
    const resultSection = root.querySelector('[data-dr-result]');
    const sharePreview = root.querySelector('[data-dr-share-preview]');
    const originalActionButton = root.querySelector('[data-dr-share]');
    const retryButton = root.querySelector('[data-dr-retry]');
    const canvas = root.querySelector('[data-dr-canvas]');

    const diaryBox = root.querySelector('[data-dr-diary-box]');
    const diaryPetInput = root.querySelector('[data-dr-diary-pet-name]');
    const diaryStateText = root.querySelector('[data-dr-diary-state-text]');
    const diaryLinks = root.querySelectorAll('[data-dr-diary-link]');
    const diaryResult = root.querySelector('[data-dr-diary-result]');
    const diaryResultText = root.querySelector('[data-dr-diary-result-text]');
    const diaryResultNote = root.querySelector('[data-dr-diary-result-note]');
    const diaryRemoveButton = root.querySelector('[data-dr-diary-remove]');
    const diaryUrl = root.dataset.diaryUrl || DEFAULT_DIARY_URL;

    const observedSummary = root.querySelector('[data-dr-observed-summary]');
    const observedChangeButton = root.querySelector('[data-dr-observed-change]');
    const observedEditor = root.querySelector('[data-dr-observed-editor]');
    const observedInput = root.querySelector('[data-dr-observed-input]');
    const observedApplyButton = root.querySelector('[data-dr-observed-apply]');
    const observedNowButton = root.querySelector('[data-dr-observed-now]');

    if (!photoInput || !submitButton || !canvas) {
      console.error('Dayrhythm Poop Checker: required elements are missing.');
      return;
    }

    let imageData = null;
    let shareCardDataUrl = null;
    let activeSubmitFrame = null;
    let diaryState = readDiaryState();
    let lastDiaryRecord = null;
    let observedMode = 'NOW';
    let customObservedAt = null;
    let diaryValidationPromise = null;
    const clientId = getOrCreateClientId();

    initDiaryUi();
    initObservedTimeUi();
    diaryValidationPromise = validateStoredDiaryState();

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        cleanupSubmitFrame();
        setLoading(false);
        diaryValidationPromise = validateStoredDiaryState();
      }
    });

    // --------------------------------------------------
    // Save / Share buttons
    // --------------------------------------------------

    const actionButton = originalActionButton;

    if (actionButton) {
      actionButton.textContent = '画像を保存・シェアする';
      actionButton.addEventListener('click', function () {
        saveOrShareCard();
      });
    }

    if (retryButton) {
      retryButton.addEventListener('click', resetForm);
    }

    if (diaryRemoveButton) {
      diaryRemoveButton.addEventListener('click', removeCurrentDiaryRecord);
    }

    // --------------------------------------------------
    // Photo
    // --------------------------------------------------

    photoInput.addEventListener('change', async function () {
      const file = photoInput.files && photoInput.files[0];

      if (!file) {
        imageData = null;
        if (fileName) fileName.textContent = 'ファイル未選択';
        if (previewWrap) previewWrap.hidden = true;
        return;
      }

      if (fileName) fileName.textContent = file.name;
      clearError();

      try {
        setProgress('写真を準備しています…', '送信しやすい大きさに整えています。');
        imageData = await normalizeImageForUpload(file);

        if (!imageData || imageData.length > 1200000) {
          throw new Error('写真を十分に軽量化できませんでした。');
        }

        if (preview) preview.src = imageData;
        if (previewWrap) previewWrap.hidden = false;
      } catch (error) {
        console.error('Photo normalization error:', error);
        imageData = null;
        if (previewWrap) previewWrap.hidden = true;
        showError(
          '写真を読み込めませんでした。別の写真、またはスクリーンショットでお試しください。'
        );
      } finally {
        if (!submitButton.disabled) {
          submitButton.textContent = '今日のうんちを見てもらう';
        }
      }
    });

    submitButton.addEventListener('click', submitForm);

    async function submitForm(event) {
      if (event) event.preventDefault();
      clearError();

      const hardness = root.querySelector('[data-dr-hardness]:checked');
      const amount = root.querySelector('[data-dr-amount]:checked');

      if (!imageData) {
        showError('うんちの写真を選んでください。');
        scrollToElement(errorBox);
        return;
      }

      if (!hardness) {
        showError('拾ったときの状態を選んでください。');
        scrollToElement(errorBox);
        return;
      }

      if (!amount) {
        showError('いつもと比べた量を選んでください。');
        scrollToElement(errorBox);
        return;
      }

      const diaryContext = await prepareDiaryContextForAnalysis();
      const observed = getObservedAtForSubmit();

      await runAnalysis({
        image: imageData,
        hardness: hardness.value,
        amount: amount.value,
        clientId: clientId,
        observedAt: observed.observedAt,
        observedAtSource: observed.observedAtSource,
        bookId: diaryContext ? diaryContext.bookId : '',
        bookToken: diaryContext ? diaryContext.bookToken : '',
        petId: diaryContext ? (diaryContext.petId || '') : '',
        petName: diaryContext ? (diaryContext.petName || '') : ''
      });
    }

    // ==================================================
    // ANALYSIS FLOW
    // ==================================================

    async function runAnalysis(data) {
      shareCardDataUrl = null;
      lastDiaryRecord = null;
      if (diaryResult) diaryResult.hidden = true;
      if (diaryResultNote) diaryResultNote.hidden = true;
      if (diaryRemoveButton) {
        diaryRemoveButton.hidden = true;
        diaryRemoveButton.disabled = false;
        diaryRemoveButton.textContent = 'この記録を残さない';
      }
      if (resultSection) resultSection.hidden = true;
      setLoading(true);

      try {
        // 1) JSONP GETでjob発行
        setProgress('解析の準備をしています…', '通信の準備をしています。');

        const jobPayload = await directGetViaJsonp(
          gasEndpoint,
          { action: 'init', client_id: data.clientId },
          DIRECT_GET_TIMEOUT_MS
        );

        if (!jobPayload || !jobPayload.success) {
          throw createPayloadError(jobPayload, '解析の準備に失敗しました。');
        }

        if (!jobPayload.job_id || !jobPayload.direct_token || !jobPayload.read_token) {
          throw new Error('解析サーバーから有効な受付情報を取得できませんでした。');
        }

        const job = {
          jobId: jobPayload.job_id,
          token: jobPayload.direct_token,
          readToken: jobPayload.read_token
        };

        // 2) hidden iframe POSTで写真と回答を送信
        setProgress('写真をAIへ送っています…', 'そのまま少しお待ちください。');
        activeSubmitFrame = submitDirectlyToGas(gasEndpoint, job, data);

        // 3) statusをJSONPで確認
        const doneStatus = await waitForJob(
          gasEndpoint,
          job,
          data.clientId
        );

        // 新方式：status内の小容量JSONをそのまま利用する。
        const result = doneStatus.result || null;

        if (!result || !result.analysis) {
          throw new Error('解析結果を取得できませんでした。');
        }

        if (!result.analysis.image_usable) {
          showImageNotUsable(result.analysis);
          return;
        }

        setProgress('カードを仕上げています…', '固定キャラクター素材を読み込んでいます。');
        await createShareCard(result, data.observedAt);

        if (result.historySaveError) {
          console.warn('History save error:', result.historySaveError);
        }

        handleDiaryAnalysisResult(result);

        if (resultSection) {
          resultSection.hidden = false;
          scrollToElement(resultSection);
        }
      } catch (error) {
        console.error(error);
        showError(formatUserError(error));
        scrollToElement(errorBox);
      } finally {
        cleanupSubmitFrame();
        setLoading(false);
      }
    }

    // ==================================================
    // JSONP GET
    // ==================================================

    function directGetViaJsonp(endpoint, values, timeoutMs) {
      return new Promise(function (resolve, reject) {
        const callbackName =
          '__drPoopCb_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);

        const script = document.createElement('script');
        let settled = false;
        let timeoutTimer = null;

        function cleanup() {
          if (timeoutTimer) clearTimeout(timeoutTimer);
          script.onload = null;
          script.onerror = null;
          if (script.parentNode) script.parentNode.removeChild(script);

          try {
            delete window[callbackName];
          } catch (error) {
            window[callbackName] = undefined;
          }
        }

        function finishResolve(payload) {
          if (settled) return;
          settled = true;
          cleanup();
          resolve(payload);
        }

        function finishReject(error) {
          if (settled) return;
          settled = true;
          cleanup();
          reject(error);
        }

        window[callbackName] = finishResolve;
        script.async = true;

        script.onerror = function () {
          const error = new Error('解析サーバーから応答を読み込めませんでした。ページを再読み込みして、もう一度お試しください。');
          error.code = 'JSONP_LOAD_ERROR';
          finishReject(error);
        };

        timeoutTimer = setTimeout(function () {
          const error = new Error('解析サーバーとの通信に時間がかかっています。ページを再読み込みして、もう一度お試しください。');
          error.code = 'JSONP_TIMEOUT';
          finishReject(error);
        }, timeoutMs || DIRECT_GET_TIMEOUT_MS);

        const params = new URLSearchParams();

        Object.keys(values || {}).forEach(function (key) {
          const value = values[key];
          if (value !== undefined && value !== null) {
            params.set(key, String(value));
          }
        });

        params.set('callback', callbackName);
        params.set('_drt', String(Date.now()));

        const separator = endpoint.indexOf('?') === -1 ? '?' : '&';
        script.src = endpoint + separator + params.toString();
        document.head.appendChild(script);
      });
    }

    function createPayloadError(payload, fallbackMessage) {
      const error = new Error(
        payload && payload.error ? payload.error : fallbackMessage
      );

      if (payload && payload.code) error.code = payload.code;
      return error;
    }

    // ==================================================
    // DIRECT POST
    // ==================================================

    function submitDirectlyToGas(endpoint, job, data) {
      cleanupSubmitFrame();

      const frameName =
        'dr-gas-submit-' + Date.now() + '-' + Math.random().toString(36).slice(2);

      const iframe = document.createElement('iframe');
      iframe.name = frameName;
      iframe.title = 'analysis-submit';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText =
        'position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;border:0;left:-10000px;top:-10000px;';
      document.body.appendChild(iframe);

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = endpoint;
      form.target = frameName;
      form.acceptCharset = 'UTF-8';
      form.style.display = 'none';

      appendHiddenField(form, 'job_id', job.jobId);
      appendHiddenField(form, 'token', job.token);

      const payloadField = document.createElement('textarea');
      payloadField.name = 'payload';
      payloadField.value = JSON.stringify(data);
      payloadField.style.display = 'none';
      form.appendChild(payloadField);

      document.body.appendChild(form);
      form.submit();

      setTimeout(function () {
        if (form.parentNode) form.parentNode.removeChild(form);
      }, 1000);

      return iframe;
    }

    function appendHiddenField(form, name, value) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    function cleanupSubmitFrame() {
      if (activeSubmitFrame && activeSubmitFrame.parentNode) {
        activeSubmitFrame.parentNode.removeChild(activeSubmitFrame);
      }
      activeSubmitFrame = null;
    }

    // ==================================================
    // POLLING
    // ==================================================

    async function waitForJob(endpoint, job, currentClientId) {
      const startedAt = Date.now();
      let firstPoll = true;
      let createdStartedAt = null;
      let consecutiveStatusFailures = 0;

      while (Date.now() - startedAt < POLL_TIMEOUT_MS) {
        if (firstPoll) {
          await sleep(700);
          firstPoll = false;
        }

        let payload = null;

        try {
          payload = await directGetViaJsonp(
            endpoint,
            {
              action: 'status',
              job_id: job.jobId,
              client_id: currentClientId,
              read_token: job.readToken
            },
            STATUS_GET_TIMEOUT_MS
          );

          consecutiveStatusFailures = 0;
        } catch (error) {
          const isRetriableStatusError =
            error && (error.code === 'JSONP_TIMEOUT' || error.code === 'JSONP_LOAD_ERROR');

          if (!isRetriableStatusError) {
            throw error;
          }

          if (Date.now() - startedAt >= POLL_TIMEOUT_MS) {
            break;
          }

          consecutiveStatusFailures += 1;

          if (consecutiveStatusFailures > STATUS_RETRY_MAX) {
            throw new Error('通信が混み合っています。少し時間をおいて、もう一度お試しください。');
          }

          setProgress(
            '通信を再確認しています…',
            '解析は続いています。そのまま少しお待ちください。'
          );

          await sleep(STATUS_RETRY_DELAY_MS);
          continue;
        }

        if (!payload || !payload.success) {
          throw createPayloadError(payload, '解析状況を確認できませんでした。');
        }

        if (payload.status === 'DONE') return payload;

        if (payload.status === 'ERROR') {
          throw createPayloadError(payload, '解析中にエラーが発生しました。');
        }

        if (payload.status === 'CREATED') {
          if (!createdStartedAt) createdStartedAt = Date.now();

          if (Date.now() - createdStartedAt > CREATED_STATUS_MAX_MS) {
            throw new Error(
              '写真を解析サーバーへ送信できませんでした。ページを再読み込みして、もう一度お試しください。'
            );
          }

          setProgress('写真を送っています…', '送信完了まで少しお待ちください。');
        }

        if (payload.status === 'PROCESSING') {
          createdStartedAt = null;
          setProgress('AIが今日のうんちを見ています…', '写真とご回答をもとに解析しています。');
        }

        await sleep(POLL_INTERVAL_MS);
      }

      throw new Error('通信が混み合っています。少し時間をおいて、もう一度お試しください。');
    }

    // ==================================================
    // SHARE CARD
    // ==================================================

    async function createShareCard(result, observedAtIso) {
      await waitForFonts();

      const ctx = canvas.getContext('2d');
      const W = 1080;
      const H = 1920;
      canvas.width = W;
      canvas.height = H;
      ctx.clearRect(0, 0, W, H);

      const analysis = result.analysis;
      const character = result.character;
      const palette = getCardPalette(analysis.condition, character.archetypeCode);

      // Background
      const gradient = ctx.createLinearGradient(0, 0, 0, H);
      gradient.addColorStop(0, palette.skyTop);
      gradient.addColorStop(.58, palette.skyBottom);
      gradient.addColorStop(.581, '#fffdf9');
      gradient.addColorStop(1, '#f8f3ea');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, W, H);

      drawSoftSun(ctx, 870, 260, 145, palette.sun);
      drawCloud(ctx, 120, 330, .9, palette.cloud);
      drawCloud(ctx, 830, 410, .7, palette.cloud);
      drawHill(ctx, -50, 875, 1180, 350, palette.hillBack);
      drawHill(ctx, -120, 960, 1320, 350, palette.hillFront);
      drawTinyFlowers(ctx, palette.flower);

      // one’s daily logo
      // Shopify Assets / CORS に依存せず、軽量化済みPNGをJS内に埋め込んで描画する。
      try {
        const logoImage = await loadImage(CARD_LOGO_DATA_URL, false);
        const logoWidth = 245;
        const logoHeight = Math.round(logoWidth * (logoImage.naturalHeight / logoImage.naturalWidth));

        ctx.save();
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(logoImage, 42, 28, logoWidth, logoHeight);
        ctx.restore();
      } catch (error) {
        console.warn("one's daily logo could not be loaded:", error);
        drawLogoFallback(ctx);
      }

      // Condition badge
      ctx.font = getCanvasFont(33, 900);
      const badgeWidth = Math.max(
        405,
        ctx.measureText(character.conditionLabel).width + 105
      );
      drawRoundedRect(ctx, W - badgeWidth - 65, 67, badgeWidth, 78, 39, palette.badge);
      ctx.fillStyle = palette.accentDark;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(character.conditionLabel, W - badgeWidth / 2 - 65, 108);

      // Name
      ctx.fillStyle = '#49362d';
      fitAndDrawCenteredText(ctx, character.name, W / 2, 225, 820, 78, 56);

      // 戦闘力
      drawRoundedRect(ctx, 330, 300, 420, 96, 48, '#855742');
      ctx.fillStyle = '#ffffff';
      ctx.font = getCanvasFont(46, 900);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('戦闘力：' + character.level, W / 2, 351);

      // Character
      const charImage = await getRenderableCharacterImage(result);
      drawCharacterWithSoftShadow(ctx, charImage, 65, 405, 950, 650);

      // Stats panel
      ctx.save();
      ctx.shadowColor = 'rgba(61,43,34,.08)';
      ctx.shadowBlur = 22;
      ctx.shadowOffsetY = 7;
      drawRoundedRect(ctx, 58, 1060, 964, 565, 48, '#ffffff');
      ctx.restore();

      ctx.textAlign = 'left';
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#a18a7b';
      ctx.font = getCanvasLatinFont(24, 800);
      ctx.fillText('TODAY’S CONDITION', 120, 1114);

      const cardObservedDate = observedAtIso ? new Date(observedAtIso) : new Date();
      const safeCardDate = Number.isNaN(cardObservedDate.getTime())
        ? new Date()
        : cardObservedDate;

      ctx.textAlign = 'right';
      ctx.fillStyle = '#a18a7b';
      ctx.font = getCanvasFont(23, 700);
      ctx.fillText(formatJapaneseDate(safeCardDate), 900, 1114);
      ctx.textAlign = 'left';

      drawDivider(ctx, 120, 1150, 900, '#eee7e1');

      const rows = [
        { label: '硬さ', value: character.hardnessStars + '  ' + character.hardnessLabel },
        { label: 'スタイル', value: character.shapeLabel },
        { label: '体長', value: character.height },
        { label: '水分', value: character.moistureStars + '  ' + character.moistureLabel },
        { label: '色', value: character.colorLabel }
      ];

      const firstY = 1212;
      const rowHeight = 82;

      rows.forEach(function (row, index) {
        const y = firstY + index * rowHeight;
        drawStatRowFixed(ctx, 125, 355, y, row.label, row.value, palette);

        if (index < rows.length - 1) {
          drawDivider(ctx, 120, y + 40, 900, '#f0eae4');
        }
      });

      // Comment
      drawRoundedRect(ctx, 100, 1655, 880, 130, 40, palette.comment);
      ctx.fillStyle = '#4e3a31';
      ctx.font = getCanvasFont(34, 900);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      drawTextLinesCentered(ctx, character.comment, W / 2, 1720, 770, 44);

// App CTA
ctx.textAlign = 'center';
ctx.textBaseline = 'alphabetic';

ctx.fillStyle = '#5f493f';
ctx.font = getCanvasFont(30, 900);
ctx.fillText('うちの子は、どんなキャラになる？', W / 2, 1822);

// Search box
const searchBoxW = 560;
const searchBoxH = 68;
const searchBoxX = (W - searchBoxW) / 2;
const searchBoxY = 1846;
const searchBoxR = 34;

// rounded rectangle
ctx.save();
ctx.beginPath();
ctx.moveTo(searchBoxX + searchBoxR, searchBoxY);
ctx.lineTo(searchBoxX + searchBoxW - searchBoxR, searchBoxY);
ctx.quadraticCurveTo(searchBoxX + searchBoxW, searchBoxY, searchBoxX + searchBoxW, searchBoxY + searchBoxR);
ctx.lineTo(searchBoxX + searchBoxW, searchBoxY + searchBoxH - searchBoxR);
ctx.quadraticCurveTo(searchBoxX + searchBoxW, searchBoxY + searchBoxH, searchBoxX + searchBoxW - searchBoxR, searchBoxY + searchBoxH);
ctx.lineTo(searchBoxX + searchBoxR, searchBoxY + searchBoxH);
ctx.quadraticCurveTo(searchBoxX, searchBoxY + searchBoxH, searchBoxX, searchBoxY + searchBoxH - searchBoxR);
ctx.lineTo(searchBoxX, searchBoxY + searchBoxR);
ctx.quadraticCurveTo(searchBoxX, searchBoxY, searchBoxX + searchBoxR, searchBoxY);
ctx.closePath();

ctx.fillStyle = '#ffffff';
ctx.strokeStyle = '#d9cec5';
ctx.lineWidth = 3;
ctx.fill();
ctx.stroke();

// magnifying glass icon
const iconCx = searchBoxX + 44;
const iconCy = searchBoxY + searchBoxH / 2;
ctx.strokeStyle = '#8f7c70';
ctx.lineWidth = 4;

ctx.beginPath();
ctx.arc(iconCx, iconCy - 2, 11, 0, Math.PI * 2);
ctx.stroke();

ctx.beginPath();
ctx.moveTo(iconCx + 8, iconCy + 6);
ctx.lineTo(iconCx + 18, iconCy + 16);
ctx.stroke();

// search text
ctx.fillStyle = '#8f7c70';
ctx.textAlign = 'left';
ctx.textBaseline = 'middle';
ctx.font = getCanvasFont(24, 700);
ctx.fillText('ワンズデイリー　うんち', searchBoxX + 76, searchBoxY + searchBoxH / 2);

ctx.restore();

      // Canvasを完成画像としてプレビュー・共有用に保存
      shareCardDataUrl = canvas.toDataURL('image/png');
      if (sharePreview) sharePreview.src = shareCardDataUrl;
    }

    // ==================================================
    // CHARACTER ASSET
    // ==================================================

    async function getRenderableCharacterImage(result) {
      const character = result.character || {};

      if (!character.assetSlug || !character.variant) {
        throw new Error('キャラクター画像情報が見つかりませんでした。');
      }

      const assetUrl = getCharacterAssetUrl(character.assetSlug, character.variant);
      const source = await loadImage(assetUrl, true);

      return createTintedCharacterCanvas(
        source,
        CHARACTER_COLORS[character.colorKey] || CHARACTER_COLORS.BROWN_MEDIUM
      );
    }

    function getCharacterAssetUrl(assetSlug, variant) {
      const slug = String(assetSlug || '').trim();
      const vv = String(variant || '').padStart(2, '0');

      if (!/^[a-z0-9]+$/.test(slug) || !/^\d{2}$/.test(vv)) {
        throw new Error('キャラクター素材指定が不正です。');
      }

      if (slug === 'marumarun') {
        const filename = MARUMARUN_FILES[vv];
        if (!filename) throw new Error('まるまるん素材が見つかりません：' + vv);
        return ASSET_BASE + filename;
      }

      return ASSET_BASE + 'dr-' + slug + '-var' + vv + '.png';
    }

    async function loadImage(src, useCors) {
      const img = new Image();
      if (useCors) img.crossOrigin = 'anonymous';
      img.src = src;

      if (img.decode) {
        try {
          await img.decode();
          return img;
        } catch (error) {
          // fallback below
        }
      }

      return new Promise(function (resolve, reject) {
        if (img.complete && img.naturalWidth > 0) {
          resolve(img);
          return;
        }

        img.onload = function () { resolve(img); };
        img.onerror = function () {
          reject(new Error('キャラクター画像を読み込めませんでした。'));
        };
      });
    }

    // 固定PNGの形・表情・透明度を維持し、体色を解析色へ寄せる。
    function createTintedCharacterCanvas(img, targetHex) {
      const width = img.naturalWidth || img.width;
      const height = img.naturalHeight || img.height;
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = width;
      tempCanvas.height = height;

      const ctx = tempCanvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, width, height);

      const imageData = ctx.getImageData(0, 0, width, height);
      const pixels = imageData.data;

      let minX = width;
      let minY = height;
      let maxX = -1;
      let maxY = -1;

      for (let y = 0; y < height; y += 2) {
        for (let x = 0; x < width; x += 2) {
          const a = pixels[(y * width + x) * 4 + 3];
          if (a > 15) {
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
          }
        }
      }

      if (maxX < 0 || maxY < 0) return tempCanvas;

      const boundsW = Math.max(1, maxX - minX);
      const boundsH = Math.max(1, maxY - minY);
      const target = hexToRgb(targetHex);
      const blend = .78;

      for (let y = 0; y < height; y++) {
        const ny = (y - minY) / boundsH;

        for (let x = 0; x < width; x++) {
          const i = (y * width + x) * 4;
          const alpha = pixels[i + 3];
          if (alpha === 0) continue;

          const r = pixels[i];
          const g = pixels[i + 1];
          const b = pixels[i + 2];
          const luminance = .2126 * r + .7152 * g + .0722 * b;

          // 輪郭・目などの暗部と白ハイライトを保持。
          if (luminance < 55 || luminance > 245) continue;

          // 頬のピンクをできるだけ保持。
          const nx = (x - minX) / boundsW;
          const cheekColor =
            r > 215 &&
            (r - g) > 75 &&
            b > 105 &&
            g < 180;

          const cheekZone =
            ny > .38 &&
            ny < .78 &&
            ((nx > .08 && nx < .43) || (nx > .57 && nx < .92));

          if (cheekColor && cheekZone) continue;

          const factor = Math.max(.32, Math.min(1.55, luminance / 165));
          const tr = Math.min(255, target.r * factor);
          const tg = Math.min(255, target.g * factor);
          const tb = Math.min(255, target.b * factor);

          pixels[i] = Math.round(r * (1 - blend) + tr * blend);
          pixels[i + 1] = Math.round(g * (1 - blend) + tg * blend);
          pixels[i + 2] = Math.round(b * (1 - blend) + tb * blend);
        }
      }

      ctx.putImageData(imageData, 0, 0);
      return tempCanvas;
    }

    function hexToRgb(hex) {
      const normalized = String(hex || '').replace('#', '').trim();
      if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
        return { r: 139, g: 84, b: 45 };
      }

      return {
        r: parseInt(normalized.slice(0, 2), 16),
        g: parseInt(normalized.slice(2, 4), 16),
        b: parseInt(normalized.slice(4, 6), 16)
      };
    }

    function getVisibleImageBounds(img) {
      const width = img.naturalWidth || img.width;
      const height = img.naturalHeight || img.height;
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = width;
      tempCanvas.height = height;

      const tempCtx = tempCanvas.getContext('2d', { willReadFrequently: true });
      tempCtx.drawImage(img, 0, 0, width, height);
      const pixels = tempCtx.getImageData(0, 0, width, height).data;

      let minX = width;
      let minY = height;
      let maxX = -1;
      let maxY = -1;
      const step = 2;

      for (let y = 0; y < height; y += step) {
        for (let x = 0; x < width; x += step) {
          const alpha = pixels[(y * width + x) * 4 + 3];
          if (alpha > 15) {
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
          }
        }
      }

      if (maxX < 0 || maxY < 0) {
        return { sx: 0, sy: 0, sw: width, sh: height };
      }

      const padding = 18;
      const sx = Math.max(0, minX - padding);
      const sy = Math.max(0, minY - padding);
      const ex = Math.min(width, maxX + padding);
      const ey = Math.min(height, maxY + padding);

      return {
        sx: sx,
        sy: sy,
        sw: Math.max(1, ex - sx),
        sh: Math.max(1, ey - sy)
      };
    }

    function drawCharacterWithSoftShadow(ctx, img, x, y, boxWidth, boxHeight) {
      const bounds = getVisibleImageBounds(img);
      const ratio = Math.min(boxWidth / bounds.sw, boxHeight / bounds.sh) * .96;
      const width = bounds.sw * ratio;
      const height = bounds.sh * ratio;
      const dx = x + (boxWidth - width) / 2;
      const dy = y + (boxHeight - height) / 2;

      ctx.save();
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
      ctx.shadowColor = 'rgba(61,43,34,.16)';
      ctx.shadowBlur = 27;
      ctx.shadowOffsetY = 13;
      ctx.drawImage(
        img,
        bounds.sx,
        bounds.sy,
        bounds.sw,
        bounds.sh,
        dx,
        dy,
        width,
        height
      );
      ctx.restore();
    }

    // ==================================================
    // PHOTO NORMALIZE
    // ==================================================

    async function normalizeImageForUpload(file) {
      const dataUrl = await readFileAsDataUrl(file);
      const img = await loadImage(dataUrl, false);

      let maxSide = UPLOAD_MAX_SIDE;
      let quality = UPLOAD_INITIAL_QUALITY;
      let attempt = 0;

      while (attempt < 10) {
        const resized = resizeToJpegDataUrl(img, maxSide, quality);

        if (resized.length <= UPLOAD_MAX_DATA_URL_CHARS) {
          return resized;
        }

        if (quality > UPLOAD_MIN_QUALITY) {
          quality = Math.max(UPLOAD_MIN_QUALITY, quality - .04);
        } else {
          maxSide = Math.max(520, Math.round(maxSide * .86));
        }

        attempt += 1;
      }

      return resizeToJpegDataUrl(img, Math.max(520, maxSide), UPLOAD_MIN_QUALITY);
    }

    function readFileAsDataUrl(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function (event) { resolve(event.target.result); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    function resizeToJpegDataUrl(img, maxSide, quality) {
      let width = img.naturalWidth || img.width;
      let height = img.naturalHeight || img.height;
      const longest = Math.max(width, height);

      if (longest > maxSide) {
        const scale = maxSide / longest;
        width = Math.max(1, Math.round(width * scale));
        height = Math.max(1, Math.round(height * scale));
      }

      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = width;
      tempCanvas.height = height;
      const ctx = tempCanvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);
      return tempCanvas.toDataURL('image/jpeg', quality);
    }

    // ==================================================
    // LOADING / ERROR
    // ==================================================

    function setLoading(isLoading) {
      submitButton.disabled = isLoading;
      if (loading) loading.hidden = !isLoading;
      if (isLoading) {
        submitButton.textContent = '解析しています…';
      } else {
        submitButton.textContent = '今日のうんちを見てもらう';
      }
    }

    function setProgress(title, text) {
      if (loadingTitle && title) loadingTitle.textContent = title;
      if (loadingText && text) loadingText.textContent = text;
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function showImageNotUsable(analysis) {
      setLoading(false);

      const messages = {
        DARK: '写真が少し暗くて、うんちの状態をよく確認できませんでした。',
        BLURRY: '写真が少しぼやけていて、うんちの状態をよく確認できませんでした。',
        TOO_SMALL: '写真の中でうんちが小さすぎて、状態を確認できませんでした。',
        OCCLUDED: 'うんちの一部が隠れていて、状態を確認できませんでした。',
        NOT_STOOL: 'うんちとして確認できるものを見つけられませんでした。',
        OTHER: '今回の写真では、状態を十分に確認できませんでした。'
      };

      const quality = analysis.image_quality || 'OTHER';
      showError(
        'うまく観察できませんでした。\n\n' +
        (messages[quality] || messages.OTHER) +
        '\n\nもう少し明るい場所で、うんち全体が大きめに写るように撮ってみてください。'
      );
      scrollToElement(errorBox);
    }

    function formatUserError(error) {
      if (!error) return 'エラーが発生しました。もう一度お試しください。';
      return error.message || String(error);
    }

    function scrollToElement(element) {
      if (!element || !element.scrollIntoView) return;
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function sleep(ms) {
      return new Promise(function (resolve) { setTimeout(resolve, ms); });
    }

    // ==================================================
    // SAVE / SHARE
    // ==================================================

    async function saveOrShareCard() {
      if (!shareCardDataUrl) {
        alert('カードがまだできていません。');
        return;
      }

      try {
        const blob = await dataUrlToBlob(shareCardDataUrl);
        const file = new File([blob], createCardFileName(), { type: 'image/png' });

        let canShare = false;
        try {
          canShare =
            !!navigator.share &&
            (!navigator.canShare || navigator.canShare({ files: [file] }));
        } catch (error) {
          canShare = false;
        }

        if (canShare) {
          try {
            await navigator.share({
  files: [file],
  title: '今日のうんちキャラ',
  text:
    '今日のうんちキャラができました！\n\n' +
    'うちの子は、どんなキャラになる？\n' +
    '愛犬の今日のうんちから、キャラクターをつくれます。\n' +
    SHARE_APP_URL
});
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') return;
            console.warn('Native share failed, falling back to download:', error);
          }
        }

        downloadBlob(blob, createCardFileName());
      } catch (error) {
        console.error(error);
        alert('画像を保存・シェアできませんでした。');
      }
    }

    function dataUrlToBlob(dataUrl) {
      return fetch(dataUrl).then(function (response) { return response.blob(); });
    }

    function downloadBlob(blob, fileNameValue) {
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = fileNameValue;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 30000);
    }

    function createCardFileName() {
      const now = new Date();
      const yyyy = now.getFullYear();
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const dd = String(now.getDate()).padStart(2, '0');
      return 'onesdaily-poop-character-' + yyyy + mm + dd + '.png';
    }

    function resetForm() {
      imageData = null;
      shareCardDataUrl = null;
      cleanupSubmitFrame();
      clearError();
      setLoading(false);

      photoInput.value = '';
      if (fileName) fileName.textContent = 'ファイル未選択';
      if (previewWrap) previewWrap.hidden = true;
      if (preview) preview.removeAttribute('src');

      root.querySelectorAll('[data-dr-hardness], [data-dr-amount]').forEach(function (input) {
        input.checked = false;
      });

      if (resultSection) resultSection.hidden = true;
      if (diaryResult) diaryResult.hidden = true;
      if (diaryResultNote) diaryResultNote.hidden = true;
      lastDiaryRecord = null;
      setObservedNow();
      scrollToElement(root);
    }

    // ==================================================
    // OBSERVED TIME / ANONYMOUS POOP DIARY v1.4
    // ==================================================

    function initObservedTimeUi() {
      setObservedNow();
      updateObservedInputBounds();

      if (observedChangeButton) {
        observedChangeButton.addEventListener('click', function () {
          if (!observedEditor) return;
          observedEditor.hidden = !observedEditor.hidden;
          if (!observedEditor.hidden && observedInput) {
            updateObservedInputBounds();
            observedInput.value = toLocalDateTimeInputValue(customObservedAt || new Date());
            observedInput.focus();
          }
        });
      }

      if (observedInput) {
        const previewObservedTime = function () {
          if (!observedInput.value) return;

          const chosen = new Date(observedInput.value);
          if (isNaN(chosen.getTime())) return;

          const now = new Date();
          const minTime = now.getTime() - 7 * 24 * 60 * 60 * 1000;
          const maxTime = now.getTime() + 15 * 60 * 1000;

          if (chosen.getTime() < minTime || chosen.getTime() > maxTime) return;

          observedMode = 'CUSTOM';
          customObservedAt = chosen;
          updateObservedSummary();
        };

        observedInput.addEventListener('input', previewObservedTime);
        observedInput.addEventListener('change', previewObservedTime);
      }

      if (observedApplyButton) {
        observedApplyButton.addEventListener('click', function () {
          if (!observedInput || !observedInput.value) {
            showError('排便時刻を選んでください。');
            return;
          }

          const chosen = new Date(observedInput.value);
          if (isNaN(chosen.getTime())) {
            showError('排便時刻を確認してください。');
            return;
          }

          const now = new Date();
          const minTime = now.getTime() - 7 * 24 * 60 * 60 * 1000;
          const maxTime = now.getTime() + 15 * 60 * 1000;

          if (chosen.getTime() < minTime || chosen.getTime() > maxTime) {
            showError('排便時刻は、現在から7日前までの範囲で選んでください。');
            return;
          }

          clearError();
          observedMode = 'CUSTOM';
          customObservedAt = chosen;
          updateObservedSummary();
          if (observedEditor) observedEditor.hidden = true;
        });
      }

      if (observedNowButton) {
        observedNowButton.addEventListener('click', function () {
          clearError();
          setObservedNow();
        });
      }
    }

    function setObservedNow() {
      observedMode = 'NOW';
      customObservedAt = null;
      if (observedEditor) observedEditor.hidden = true;
      updateObservedSummary();
    }

    function updateObservedSummary() {
      if (!observedSummary) return;
      observedSummary.textContent = observedMode === 'CUSTOM' && customObservedAt
        ? formatObservedSummary(customObservedAt)
        : 'いま';
    }

    function getObservedAtForSubmit() {
      if (observedMode === 'CUSTOM' && customObservedAt) {
        return {
          observedAt: customObservedAt.toISOString(),
          observedAtSource: 'CUSTOM'
        };
      }

      return {
        observedAt: new Date().toISOString(),
        observedAtSource: 'NOW'
      };
    }

    function updateObservedInputBounds() {
      if (!observedInput) return;
      const now = new Date();
      observedInput.min = toLocalDateTimeInputValue(new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000));
      observedInput.max = toLocalDateTimeInputValue(new Date(now.getTime() + 15 * 60 * 1000));
    }

    function toLocalDateTimeInputValue(date) {
      const d = date instanceof Date ? date : new Date();
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + min;
    }

    function formatObservedSummary(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return yyyy + '/' + mm + '/' + dd + ' ' + hh + ':' + min;
    }

    function readDiaryState() {
      try {
        const raw = localStorage.getItem(DIARY_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.bookId || !parsed.bookToken) {
          localStorage.removeItem(DIARY_STORAGE_KEY);
          return null;
        }
        return parsed;
      } catch (error) {
        try { localStorage.removeItem(DIARY_STORAGE_KEY); } catch (ignored) {}
        return null;
      }
    }

    function writeDiaryState(value) {
      diaryState = value || null;
      try {
        if (diaryState) {
          localStorage.setItem(DIARY_STORAGE_KEY, JSON.stringify(diaryState));
        } else {
          localStorage.removeItem(DIARY_STORAGE_KEY);
        }
      } catch (error) {
        console.warn('Diary localStorage error:', error);
      }
      initDiaryUi();
    }

    function isDefinitiveDiaryInvalidCode(code) {
      return [
        'DIARY_NOT_FOUND',
        'DIARY_TOKEN_INVALID',
        'DIARY_TOKEN_MISMATCH',
        'DIARY_DELETED'
      ].indexOf(String(code || '')) !== -1;
    }

    function resetInvalidDiaryState() {
      diaryState = null;
      lastDiaryRecord = null;
      try { localStorage.removeItem(DIARY_STORAGE_KEY); } catch (error) {
        console.warn('Diary localStorage reset error:', error);
      }
      if (diaryPetInput) diaryPetInput.value = '';
      if (diaryResult) diaryResult.hidden = true;
      if (diaryResultNote) diaryResultNote.hidden = true;
      if (diaryRemoveButton) diaryRemoveButton.hidden = true;
      initDiaryUi();
    }

    async function validateStoredDiaryState() {
      const stored = diaryState || readDiaryState();
      if (!stored || !stored.bookId || !stored.bookToken) return null;

      try {
        const payload = await directGetViaJsonp(
          gasEndpoint,
          {
            action: 'diary_history',
            book_id: stored.bookId,
            book_token: stored.bookToken,
            pet_id: stored.petId || '',
            days: '7'
          },
          DIRECT_GET_TIMEOUT_MS
        );

        if (!payload || !payload.success) {
          throw createPayloadError(payload, 'うんち手帳を確認できませんでした。');
        }

        const pet = payload.pet || null;
        if (pet) {
          stored.petId = pet.petId || stored.petId || '';
          stored.petName = pet.petName || stored.petName || '';
          diaryState = stored;
          try { localStorage.setItem(DIARY_STORAGE_KEY, JSON.stringify(stored)); } catch (error) {}
          initDiaryUi();
        }
        return stored;
      } catch (error) {
        if (isDefinitiveDiaryInvalidCode(error.code)) {
          // 古い手帳ID・失効済み端末トークンなどを検知したら、
          // ユーザー操作なしで端末を初期状態へ戻す。
          resetInvalidDiaryState();
          return null;
        }

        // 一時的な通信障害では手帳情報を消さない。
        console.warn('Diary validation skipped:', error);
        return stored;
      }
    }

    function initDiaryUi() {
      if (diaryLinks && diaryLinks.length) {
        diaryLinks.forEach(function (link) { link.href = diaryUrl; });
      }

      if (!diaryBox) return;

      const state = diaryState || readDiaryState();
      diaryState = state;

      if (state && state.petName) {
        if (diaryStateText) {
          diaryStateText.textContent = state.petName + 'の記録を、うんち手帳へ自動で残します。';
        }
        if (diaryPetInput) {
          diaryPetInput.value = state.petName;
          const wrapper = diaryPetInput.closest('[data-dr-diary-new]');
          if (wrapper) wrapper.hidden = true;
        }
        diaryLinks.forEach(function (link) { link.hidden = false; });
      } else {
        if (diaryStateText) {
          diaryStateText.textContent = '愛犬のお名前を入れると、ログイン不要の「うんち手帳」に解析結果を残せます。';
        }
        if (diaryPetInput) {
          const wrapper = diaryPetInput.closest('[data-dr-diary-new]');
          if (wrapper) wrapper.hidden = false;
        }
        diaryLinks.forEach(function (link) { link.hidden = !(state && state.bookId); });
      }
    }

    async function prepareDiaryContextForAnalysis() {
      if (diaryValidationPromise) {
        try { await diaryValidationPromise; } catch (ignored) {}
      }

      let state = diaryState || readDiaryState();

      if (state && state.bookId && state.bookToken) {
        return state;
      }

      const petName = diaryPetInput ? String(diaryPetInput.value || '').trim() : '';
      if (!petName) return null;

      if (diaryStateText) diaryStateText.textContent = 'うんち手帳を準備しています…';

      try {
        const payload = await directGetViaJsonp(
          gasEndpoint,
          { action: 'diary_bootstrap', client_id: clientId },
          DIRECT_GET_TIMEOUT_MS
        );

        if (!payload || !payload.success || !payload.book_id || !payload.book_token) {
          throw createPayloadError(payload, 'うんち手帳を準備できませんでした。');
        }

        state = {
          bookId: payload.book_id,
          bookToken: payload.book_token,
          recoveryCode: payload.recovery_code || '',
          petId: '',
          petName: petName,
          createdAt: new Date().toISOString()
        };

        writeDiaryState(state);
        return state;

      } catch (error) {
        console.warn('Diary bootstrap error:', error);
        if (diaryStateText) {
          diaryStateText.textContent = '今回は手帳を準備できませんでした。うんち解析はそのまま利用できます。';
        }
        return null;
      }
    }

    function handleDiaryAnalysisResult(result) {
      if (!result || !result.diary) return;

      const diary = result.diary;

      if (diary.saved) {
        const current = diaryState || readDiaryState() || {};
        current.bookId = diary.bookId || current.bookId;
        current.petId = diary.petId || current.petId || '';
        current.petName = diary.petName || current.petName || '';
        writeDiaryState(current);

        lastDiaryRecord = {
          recordId: result.historyRecordId || '',
          bookId: current.bookId || '',
          bookToken: current.bookToken || ''
        };

        if (diaryResult) diaryResult.hidden = false;
        if (diaryResultText) {
          diaryResultText.textContent = '今日の記録を、' + (current.petName || '愛犬') + 'のうんち手帳に残しました。';
        }
        if (diaryResultNote) diaryResultNote.hidden = !lastDiaryRecord.recordId;
        if (diaryRemoveButton) {
          diaryRemoveButton.hidden = !lastDiaryRecord.recordId;
          diaryRemoveButton.disabled = false;
          diaryRemoveButton.textContent = 'この記録を残さない';
        }
        return;
      }

      if (diary.requested && diary.error) {
        console.warn('Diary save error:', diary.error);

        if (isDefinitiveDiaryInvalidCode(diary.errorCode)) {
          resetInvalidDiaryState();
          if (diaryResult) diaryResult.hidden = false;
          if (diaryResultText) {
            diaryResultText.textContent = '古い手帳情報を自動でリセットしました。今回のキャラクターは作成できていますが、この記録は手帳には保存されていません。';
          }
          return;
        }

        if (diaryResult) diaryResult.hidden = false;
        if (diaryResultText) {
          diaryResultText.textContent = 'キャラクターはできましたが、今回はうんち手帳への保存ができませんでした。';
        }
        if (diaryRemoveButton) diaryRemoveButton.hidden = true;
        if (diaryResultNote) diaryResultNote.hidden = true;
      }
    }

    async function removeCurrentDiaryRecord() {
      if (!lastDiaryRecord || !lastDiaryRecord.recordId) return;

      if (!window.confirm('この記録をうんち手帳から外しますか？')) return;

      if (diaryRemoveButton) {
        diaryRemoveButton.disabled = true;
        diaryRemoveButton.textContent = '記録から外しています…';
      }

      try {
        const payload = await directGetViaJsonp(
          gasEndpoint,
          {
            action: 'diary_record_remove',
            book_id: lastDiaryRecord.bookId,
            book_token: lastDiaryRecord.bookToken,
            record_id: lastDiaryRecord.recordId
          },
          DIRECT_GET_TIMEOUT_MS
        );

        if (!payload || !payload.success || !payload.removed) {
          throw createPayloadError(payload, 'うんち手帳から記録を外せませんでした。');
        }

        if (diaryResultText) {
          diaryResultText.textContent = 'この記録は、うんち手帳には残しませんでした。';
        }
        if (diaryRemoveButton) diaryRemoveButton.hidden = true;
        if (diaryResultNote) diaryResultNote.hidden = true;
        lastDiaryRecord = null;
      } catch (error) {
        console.error('Diary remove error:', error);
        if (diaryRemoveButton) {
          diaryRemoveButton.disabled = false;
          diaryRemoveButton.textContent = 'この記録を残さない';
        }
        showError(error.message || 'うんち手帳から記録を外せませんでした。');
        scrollToElement(errorBox);
      }
    }

    // ==================================================
    // CLIENT ID
    // ==================================================

    function getOrCreateClientId() {
      const key = 'onesdaily_poop_client_id';
      let id = localStorage.getItem(key);

      if (!id) {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
          id = crypto.randomUUID();
        } else {
          id = 'client_' + Date.now() + '_' + Math.random().toString(36).slice(2);
        }
        localStorage.setItem(key, id);
      }

      return id;
    }


    // ==================================================
    // CARD PALETTE
    // ==================================================

    function getCardPalette(condition, archetypeCode) {
      const base = {
        GOOD: {
          skyTop: '#dff1dd', skyBottom: '#fff3c8', hillBack: '#d8edb7',
          hillFront: '#bbdc97', badge: '#bfe6b4', comment: '#fff0bd',
          accentDark: '#497043', sun: '#ffe690', cloud: '#ffffff', flower: '#f3b7a4'
        },
        WATCH: {
          skyTop: '#fff1c6', skyBottom: '#fae7d2', hillBack: '#e8d8ad',
          hillFront: '#d7c28e', badge: '#ffe08a', comment: '#fff0c4',
          accentDark: '#77602f', sun: '#ffdb91', cloud: '#fffdfa', flower: '#e6ae8c'
        },
        ALERT: {
          skyTop: '#f7d9d4', skyBottom: '#fae9d6', hillBack: '#e7cfb4',
          hillFront: '#d6b8a2', badge: '#efb5ac', comment: '#f6d8cf',
          accentDark: '#895149', sun: '#f5ceb0', cloud: '#fff8f5', flower: '#dfaaa1'
        },
        UNDETERMINED: {
          skyTop: '#eee8e2', skyBottom: '#f7f2ea', hillBack: '#ddd4ca',
          hillFront: '#cbc0b5', badge: '#e7ddd5', comment: '#f3eae2',
          accentDark: '#6e625a', sun: '#ecdec6', cloud: '#ffffff', flower: '#ccb7aa'
        }
      };

      const palette = Object.assign({}, base[condition] || base.UNDETERMINED);

      const accents = {
        TSUYAMOCHI: { flower: '#efb3c5', comment: '#fde4eb' },
        NAGANOSUKE: { skyTop: '#dcefee' },
        KIRARIN: { sun: '#ffe170', comment: '#ffefad' },
        KACHIKOCHI: { hillBack: '#dbc4a2', hillFront: '#c5a47f' },
        BECHARON: { skyTop: '#e2ebee', skyBottom: '#f2e7df' },
        MIZUMIZU: {
          skyTop: '#d9edf4', skyBottom: '#eaf5f4',
          hillBack: '#ccdfe0', hillFront: '#b3cfd0'
        },
        IROKAWARIN: { skyTop: '#e3eccd', flower: '#d1b4c8' }
      };

      if (accents[archetypeCode]) Object.assign(palette, accents[archetypeCode]);
      return palette;
    }

    // ==================================================
    // CANVAS HELPERS
    // ==================================================

    function getCanvasFont(size, weight) {
      return weight + ' ' + size + 'px "Hiragino Sans","Yu Gothic","Noto Sans JP",sans-serif';
    }

    function getCanvasLatinFont(size, weight) {
      return weight + ' ' + size + 'px -apple-system,"Helvetica Neue",Arial,sans-serif';
    }

    async function waitForFonts() {
      if (document.fonts && document.fonts.ready) {
        try { await document.fonts.ready; } catch (error) { /* continue */ }
      }
    }

    function formatJapaneseDate(date) {
      return date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日';
    }

    function roundedRectPath(ctx, x, y, width, height, radius) {
      const r = Math.min(radius, width / 2, height / 2);
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.lineTo(x + width - r, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + r);
      ctx.lineTo(x + width, y + height - r);
      ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
      ctx.lineTo(x + r, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - r);
      ctx.lineTo(x, y + r);
      ctx.quadraticCurveTo(x, y, x + r, y);
      ctx.closePath();
    }

    function drawRoundedRect(ctx, x, y, width, height, radius, fill) {
      roundedRectPath(ctx, x, y, width, height, radius);
      ctx.fillStyle = fill;
      ctx.fill();
    }

    function drawCircle(ctx, x, y, radius, fill) {
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2);
      ctx.fillStyle = fill;
      ctx.fill();
    }

    function drawSoftSun(ctx, x, y, radius, fill) {
      ctx.save();
      ctx.globalAlpha = .55;
      ctx.shadowColor = fill;
      ctx.shadowBlur = 45;
      drawCircle(ctx, x, y, radius, fill);
      ctx.restore();
    }

    function drawCloud(ctx, x, y, scale, fill) {
      ctx.save();
      ctx.globalAlpha = .6;
      ctx.fillStyle = fill;

      [[0, 0, 55], [55, -20, 72], [125, 0, 58], [65, 25, 80]].forEach(function (circle) {
        ctx.beginPath();
        ctx.arc(
          x + circle[0] * scale,
          y + circle[1] * scale,
          circle[2] * scale,
          0,
          Math.PI * 2
        );
        ctx.fill();
      });

      ctx.restore();
    }

    function drawHill(ctx, x, y, width, height, fill) {
      ctx.save();
      ctx.fillStyle = fill;
      ctx.beginPath();
      ctx.ellipse(
        x + width / 2,
        y + height / 2,
        width / 2,
        height / 2,
        0,
        Math.PI,
        Math.PI * 2
      );
      ctx.lineTo(x + width, 1100);
      ctx.lineTo(x, 1100);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    }

    function drawTinyFlowers(ctx, flowerColor) {
      [[95, 930], [180, 1010], [855, 935], [955, 1010], [790, 995]].forEach(function (point) {
        const x = point[0];
        const y = point[1];

        for (let i = 0; i < 5; i++) {
          const angle = Math.PI * 2 * i / 5;
          drawCircle(
            ctx,
            x + Math.cos(angle) * 10,
            y + Math.sin(angle) * 10,
            8,
            flowerColor
          );
        }

        drawCircle(ctx, x, y, 6, '#f4d56b');
      });
    }

    function drawDivider(ctx, x1, y, x2, color) {
      ctx.beginPath();
      ctx.moveTo(x1, y);
      ctx.lineTo(x2, y);
      ctx.strokeStyle = color;
      ctx.lineWidth = 2;
      ctx.stroke();
    }

    function drawStatRowFixed(ctx, labelX, valueX, y, label, value, palette) {
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = palette.accentDark;
      ctx.font = getCanvasFont(29, 900);
      ctx.fillText(label, labelX, y);

      let fontSize = 30;
      ctx.font = getCanvasFont(fontSize, 800);

      while (ctx.measureText(value).width > 590 && fontSize > 21) {
        fontSize -= 1;
        ctx.font = getCanvasFont(fontSize, 800);
      }

      ctx.fillStyle = '#4f3b31';
      ctx.fillText(value, valueX, y);
    }

    function fitAndDrawCenteredText(ctx, text, centerX, y, maxWidth, initialSize, minimumSize) {
      let size = initialSize;
      ctx.font = getCanvasFont(size, 900);

      while (ctx.measureText(text).width > maxWidth && size > minimumSize) {
        size -= 2;
        ctx.font = getCanvasFont(size, 900);
      }

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, centerX, y);
    }

    function drawTextLinesCentered(ctx, text, centerX, centerY, maxWidth, lineHeight) {
      const chars = Array.from(text || '');
      const lines = [];
      let line = '';

      chars.forEach(function (char) {
        const candidate = line + char;
        if (ctx.measureText(candidate).width > maxWidth && line) {
          lines.push(line);
          line = char;
        } else {
          line = candidate;
        }
      });

      if (line) lines.push(line);
      const firstY = centerY - (lines.length - 1) * lineHeight / 2;

      lines.forEach(function (lineText, index) {
        ctx.fillText(lineText, centerX, firstY + index * lineHeight);
      });
    }
  }
})();